import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  drivingLicenseNumber: Yup.number()
    .positive("Numéro de permis invalide")
    .required("Le numéro de permis est obligatoire"),
  drivingLicenseType: Yup.string()
    .oneOf(["VL", "PL", "SPL"], "Type de permis invalide")
    .required("Le type de permis est obligatoire"),
  name: Yup.string().required("Le nom est obligatoire"),
  lastName: Yup.string().required("Le prénom est obligatoire"),
  email: Yup.string()
    .email("Format d'email invalide")
    .required("L'email est obligatoire"),
  phone: Yup.string()
    .matches(
      /^\+?\d{6,15}$/,
      "Le numéro de portable doit être au format +33123456789 ou 0123456789"
    )
    .required("Le numéro de téléphone est obligatoire"),
  civility: Yup.string().required("La civilité est obligatoire"),
  birthDate: Yup.date().required("La date de naissance est obligatoire"),
  manuallyActive: Yup.boolean().required("Le statut actif est obligatoire"),
  selectedChapters: Yup.array()
    .of(Yup.string())
    .required("La sélection des chapitres est obligatoire").min(1, "Selectionner au moins un chapitre"),
});
